import { IconUserCircle, Image } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';

import SkeletonLoading from 'components/SkeletonLoading';
import { useTranslation } from 'providers/translations/TranslationProvider';

const SIZE = 36;

const AvatarWrapper = styled.div`
  cursor: pointer;
  height: ${SIZE}px;
  width: ${SIZE}px;
  & > * {
    width: 100%;
    height: 100%;
  }
`;

export interface NavBarAvatarProps {
  loading: boolean;
  src: string;
}

export const NavBarAvatar = ({ loading, src }: NavBarAvatarProps) => {
  const { t } = useTranslation();
  const renderAvatar = () => {
    if (loading) {
      return <SkeletonLoading height={SIZE} width={SIZE} circle />;
    }

    if (src) {
      return <Image src={src} alt={t('profile_image_alt')} role="img" circle crop />;
    }

    return <IconUserCircle aria-label={t('profile_image_alt')} />;
  };
  return <AvatarWrapper data-testid="navbar-avatar">{renderAvatar()}</AvatarWrapper>;
};
